// @flow

import _ from 'lodash/fp';
import {
  GET_REQUEST, GET_SUCCESS,
  GET_FAILURE, FILTER,
  SORT,
} from '../actions/userList';
import type {UserListAction} from '../actions/userList';

export type UserListState = {
  error: any,
  filter: {
    archived: bool,
    project: ?number,
    query: ?string
  },
  filteredUsers: any[],
  isFetching: boolean,
  projects: any[],
  users: any[],
  sorter: Function,
}

const defaultState: UserListState = {
  error: null,
  filter: {
    archived: false,
    project: null,
    query: null,
  },
  filteredUsers: [],
  isFetching: false,
  projects: [],
  users: [],
  sorter: _.identity,
};

const isArchived =
  _.filter(u => _.isString(u.archived));

const notArchived =
  _.filter({archived: null});

const filterUsers = (projectId: ?number, archived: bool, sorter: Function, users: any[]): any[] => {
  let filterFunc = archived
    ? isArchived
    : notArchived;

  if (projectId) {
    filterFunc = _.flow(
      filterFunc,
      _.filter({projectId})
    );
  }

  return _.flow(
    filterFunc,
    sorter,
  )(users);
};

const getProjects = _.flow(
  _.filter(u => !_.isNil(u.projectId)),
  _.map(u => ({
    id: u.projectId,
    name: u.projectName,
  })),
  _.uniqBy('id')
);

const userList = (state: UserListState = defaultState, action: UserListAction): UserListState => {
  switch (action.type) {
    case FILTER:
      return {
        ...state,
        filter: {
          archived: action.archived,
          project: action.project,
          query: action.query,
        },
        filteredUsers: filterUsers(action.project, action.archived, state.sorter, state.users),
      };
    case GET_FAILURE:
      return {
        ...state,
        error: action.error,
        isFetching: false,
      };
    case GET_REQUEST:
      return {
        ...state,
        error: null,
        isFetching: true,
      };
    case GET_SUCCESS:
      return {
        ...state,
        error: null,
        filteredUsers: filterUsers(state.filter.project, state.filter.archived, state.sorter, action.users),
        isFetching: false,
        projects: getProjects(action.users),
        users: action.users,
      };
    case SORT:
      return {
        ...state,
        sorter: action.sorter,
        filteredUsers: filterUsers(state.filter.project, state.filter.archived, action.sorter, state.users),
      };
    default:
      return state;
  }
};

export default userList;



// WEBPACK FOOTER //
// ./src/reducers/userList.js